var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, styled } from '@mui/material';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Autocomplete, FormField, renderGroupedOptions } from '../common';
import { ALL_LOCATIONS_ID, ALL_QUEUES_ID } from './constants';
import { FREQUENCY_ENUM, METRICS_ENUM } from './enum';
import { useQueuesAPI, useSelectDisabledQueues } from './selectors';
var StyledStack = styled(Stack)({
  flexDirection: 'row',
  gap: '0.5rem',
  alignItems: 'center'
});
export var ControlPanelSelectors = function (_a) {
  var _b, _c;
  var control = _a.control,
    scenarioOptions = _a.scenarioOptions,
    queueOptions = _a.queueOptions,
    onQueueChange = _a.onQueueChange,
    _d = _a.locationOptions,
    locationOptions = _d === void 0 ? [] : _d,
    _e = _a.locationDisabled,
    locationDisabled = _e === void 0 ? false : _e;
  var t = useTranslation('translation').t;
  var _f = useFormContext(),
    watch = _f.watch,
    setValue = _f.setValue;
  var _g = watch(),
    frequency = _g.frequency,
    metricTab = _g.metricTab,
    planId = _g.planId;
  var queuesDisabled = useSelectDisabledQueues();
  var queuesData = useQueuesAPI(planId)[0];
  var areAllQueuesEnabled = ((_b = queuesData === null || queuesData === void 0 ? void 0 : queuesData.data) === null || _b === void 0 ? void 0 : _b.every(function (q) {
    return q.status.wat;
  })) || false;
  var nonWAPQueueIds = ((_c = queuesData === null || queuesData === void 0 ? void 0 : queuesData.data) === null || _c === void 0 ? void 0 : _c.filter(function (q) {
    return !q.status.wat;
  }).map(function (q) {
    return q.id;
  })) || [];
  var getOptionDisabled = function (option) {
    // Disable "All Queues" option for certain metrics when frequency is "Period"
    if (frequency === FREQUENCY_ENUM.PERIOD) {
      if (option.uniqueId === ALL_QUEUES_ID && ([METRICS_ENUM.SERVICE_LEVEL, METRICS_ENUM.ASA, METRICS_ENUM.OCCUPANCY, METRICS_ENUM.AHT, METRICS_ENUM.WORK_OFFERED_HANDLED].includes(metricTab) || !areAllQueuesEnabled) || nonWAPQueueIds.includes(option.uniqueId)) {
        return true;
      }
      return false;
    }
    // Disable specific queues based on state
    return option.uniqueId === -1 || queuesDisabled[option.uniqueId];
  };
  var handleQueueChange = function (value) {
    var index = queueOptions.findIndex(function (queue) {
      return queue.uniqueId === value;
    });
    onQueueChange === null || onQueueChange === void 0 ? void 0 : onQueueChange(index);
  };
  useEffect(function () {
    if (!scenarioOptions.length) return;
    var exists = scenarioOptions.some(function (opt) {
      return opt.uniqueId === planId;
    });
    if (!exists) {
      setValue('planId', scenarioOptions[0].uniqueId); // fallback to basePlandId
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scenarioOptions, setValue]);
  return _jsxs(StyledStack, {
    children: [_jsx(FormField, __assign({
      required: true,
      name: "planId",
      control: control
    }, {
      children: _jsx(Autocomplete, {
        sx: {
          minWidth: '8.5rem'
        },
        disablePortal: true,
        options: scenarioOptions,
        getOptionValue: function (o) {
          return o.uniqueId;
        }
      })
    })), _jsx(FormField, __assign({
      required: true,
      name: "queueId",
      control: control
    }, {
      children: _jsx(Autocomplete, {
        sx: {
          minWidth: '15.25rem'
        },
        disablePortal: true,
        options: queueOptions,
        getOptionValue: function (o) {
          return o.uniqueId;
        },
        getOptionDisabled: getOptionDisabled,
        groupBy: function (option) {
          var _a;
          return option.uniqueId === ALL_QUEUES_ID ? '' : (_a = option.lobName) !== null && _a !== void 0 ? _a : '';
        },
        renderGroup: renderGroupedOptions,
        onChange: handleQueueChange
      })
    })), _jsx(FormField, __assign({
      required: true,
      name: "queueLocationId",
      control: control
    }, {
      children: _jsx(Autocomplete, {
        sx: {
          minWidth: '15.25rem'
        },
        disablePortal: true,
        options: __spreadArray([{
          queueLocationId: ALL_LOCATIONS_ID,
          name: t('quickInput.allLocations')
        }], locationOptions, true),
        getOptionValue: function (option) {
          return option.queueLocationId;
        },
        disabled: locationDisabled
      })
    }))]
  });
};